/*
 *  I15TEMPLIMITBOISI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-06-18 14:40:46 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I15TEMPLIMITBOIS_SECTION_0_TITLE: "Calculez la température extérieur au dessus duquel il n'y plus de modulation",
  I15TEMPLIMITBOIS_I04DIMPUISCONS: 'Calcul Déperdition: Selon bilan de consommation',
  I15TEMPLIMITBOIS_I04DIMPUISSCHAUD: 'Calcul Déperdition: selon la surface habitable',
  I15TEMPLIMITBOIS_in_deperdition: 'Déperdition à température de base',
  I15TEMPLIMITBOIS_in_temp_consigne: 'Température de consigne',
  I15TEMPLIMITBOIS_in_puissance_chaudiere: 'Puissance chaudière bois',
  I15TEMPLIMITBOIS_in_modulation_min: 'Modulation minimum chaudière bois',
  I15TEMPLIMITBOIS_in_tempExtBase: 'Température de base ext.',
  I15TEMPLIMITBOIS_res_tempReleveAppoint_error: 'Températures ou puissances non valides',
  I15TEMPLIMITBOIS_res_tempReleveAppoint: "Température de relève de l'appoint"
}
